(function () {
  var STORAGE_KEY = 'recentlyViewedProducts';
  var MAX_ITEMS = 18;

  function getSettings(section) {
    try {
      return JSON.parse(section.getAttribute('data-section-settings') || '{}');
    } catch (e) {
      return {};
    }
  }

  function getSearchQueryString(section) {
    var settings = getSettings(section);
    var items = window.DeskyRecentlyViewed ? window.DeskyRecentlyViewed.getItems() : [];

    if (!items.length) {
      try {
        items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return '';
      }
    }

    if (settings.currentProductId) {
      items = items.filter(function (item) {
        return Number(item) !== Number(settings.currentProductId);
      });
    }

    if (!items.length) return '';

    return items
      .map(function (item) {
        return 'id:' + item;
      })
      .join(' OR ');
  }

  function initSlider(section, sectionId, productCount) {
    var desktopMax = parseInt(section.dataset.desktopMax, 10) || 4;
    var mobileMax = parseInt(section.dataset.mobileMax, 10) || 2;

    var slider = {
      sliderContainer: '#' + sectionId,
      sliderElement: '#' + sectionId + ' .bestsellers-wrapper .items .prod__item',
      elementsContainer: '#' + sectionId + ' .bestsellers-wrapper .items',
      navLeft: '#' + sectionId + ' .bestsellers-wrapper .nav-button--left',
      navRight: '#' + sectionId + ' .bestsellers-wrapper .nav-button--right',
      stop: false,
      eventsBound: false,
      updateNavigationA11y: function () {
        var self = this;
        var $ = window.jQuery;
        if (!$) return;

        var container = $(self.elementsContainer);
        if (!container.length) return;

        var currentScroll = container.scrollLeft();
        var containerWidth = container.width();
        var scrollWidth = container.get(0).scrollWidth;
        var atStart = currentScroll <= 0;
        var atEnd = currentScroll >= scrollWidth - containerWidth - 1;

        $(self.navLeft)
          .toggleClass('dis', atStart)
          .prop('disabled', atStart)
          .attr('aria-disabled', atStart ? 'true' : 'false');
        $(self.navRight)
          .toggleClass('dis', atEnd)
          .prop('disabled', atEnd)
          .attr('aria-disabled', atEnd ? 'true' : 'false');
      },
      getDelta: function () {
        var self = this;
        var $ = window.jQuery;
        var itemWidth = $(self.sliderElement).first().outerWidth(true);
        return itemWidth || $(self.sliderElement).width();
      },
      reset: function () {
        var self = this;
        var $ = window.jQuery;
        self.delta = self.getDelta();
        $(self.elementsContainer).animate({ scrollLeft: 0 }, 10);
        self.updateNavigationA11y();
      },
      scrollRight: function () {
        var self = this;
        var $ = window.jQuery;
        self.delta = self.getDelta();
        var container = $(self.elementsContainer);
        var currentScroll = container.scrollLeft();
        var containerWidth = container.width();
        var scrollWidth = container.get(0).scrollWidth;
        var nextScroll = currentScroll + self.delta;

        if (nextScroll > scrollWidth - containerWidth) {
          nextScroll = scrollWidth - containerWidth;
        }

        container.animate({ scrollLeft: nextScroll }, 300, function () {
          self.stop = false;
          self.updateNavigationA11y();
        });
      },
      scrollLeft: function () {
        var self = this;
        var $ = window.jQuery;
        self.delta = self.getDelta();
        var container = $(self.elementsContainer);
        var currentScroll = container.scrollLeft();
        var prevScroll = currentScroll - self.delta;

        if (prevScroll < 0) {
          prevScroll = 0;
        }

        container.animate({ scrollLeft: prevScroll }, 300, function () {
          self.stop = false;
          self.updateNavigationA11y();
        });
      },
      nextSlide: function () {
        this.scrollRight();
      },
      prevSlide: function () {
        this.scrollLeft();
      },
      events: function () {
        var self = this;
        var $ = window.jQuery;
        var startX;
        var endX;

        if (self.eventsBound) return;
        self.eventsBound = true;

        $(document).on('touchstart', self.sliderContainer, function (e) {
          var touch = e.originalEvent.touches[0];
          startX = touch.clientX;
        });

        $(document).on('touchend', self.sliderContainer, function (e) {
          var touch = e.originalEvent.changedTouches[0];
          endX = touch.clientX;
          var diffX = startX - endX;

          if (diffX > 50) {
            self.delta = self.getDelta();
            if (self.stop === false) {
              self.nextSlide();
              self.stop = true;
            } else {
              setTimeout(function () {
                self.stop = false;
              }, 300);
            }
          } else if (diffX < -50) {
            self.delta = self.getDelta();
            if (self.stop === false) {
              self.prevSlide();
              self.stop = true;
            } else {
              setTimeout(function () {
                self.stop = false;
              }, 300);
            }
          }
        });

        $(document).on('click', self.navLeft, function () {
          self.delta = self.getDelta();
          if (self.stop === false) {
            self.prevSlide();
            self.stop = true;
          } else {
            setTimeout(function () {
              self.stop = false;
            }, 300);
          }
        });

        $(document).on('click', self.navRight, function () {
          self.delta = self.getDelta();
          if (self.stop === false) {
            self.nextSlide();
            self.stop = true;
          } else {
            setTimeout(function () {
              self.stop = false;
            }, 300);
          }
        });

        window.addEventListener('resize', function () {
          self.reset();
        });
      },
      init: function () {
        this.reset();
        this.events();
      },
    };

    function updateSliderState() {
      var isMobile = window.innerWidth <= 768;
      var maxItems = isMobile ? mobileMax : desktopMax;

      if (productCount > maxItems) {
        section.classList.add('slider-enabled');
        section.classList.remove('slider-disabled');
      } else {
        section.classList.add('slider-disabled');
        section.classList.remove('slider-enabled');
      }
    }

    updateSliderState();
    slider.init();
    window.addEventListener('resize', updateSliderState);
  }

  function showWrapper(section) {
    var settings = getSettings(section);
    var blockId = settings.blockId || section.id.replace('desky-recently-viewed-', '');
    var embedded = settings.embedded === true;

    if (embedded) {
      var wrapper = document.getElementById('desky-recently-viewed-wrapper-' + blockId);
      if (wrapper) {
        wrapper.classList.add('desky-recently-viewed-section--loaded');
      }
      return;
    }

    var shopifySection = document.getElementById('shopify-section-' + blockId);
    if (shopifySection) {
      shopifySection.classList.add('desky-recently-viewed-section--loaded');
    }
  }

  function getSearchUrl() {
    if (window.routes && window.routes.search_url) {
      return window.routes.search_url;
    }
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'search';
  }

  function fetchProducts(section) {
    var queryString = getSearchQueryString(section);
    if (!queryString) return;

    var url =
      getSearchUrl() +
      '?view=desky-recently-viewed&type=product&q=' +
      encodeURIComponent(queryString);

    fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (content) {
        var placeholder = section.querySelector('.recently-viewed-products-placeholder');
        if (!placeholder) return;

        var tempElement = document.createElement('div');
        tempElement.innerHTML = content;

        var fetchedPlaceholder = tempElement.querySelector(
          '[data-section-type="desky-recently-viewed"] .recently-viewed-products-placeholder'
        );

        if (!fetchedPlaceholder) return;

        var items = fetchedPlaceholder.querySelectorAll('.prod__item');
        if (!items.length) return;

        placeholder.innerHTML = fetchedPlaceholder.innerHTML;
        section.dataset.productCount = items.length;
        showWrapper(section);

        var runSlider = function () {
          initSlider(section, section.id, items.length);
        };

        requestAnimationFrame(function () {
          if (window.whenJQuery) {
            window.whenJQuery(runSlider);
          } else if (window.jQuery) {
            runSlider();
          }
        });
      })
      .catch(function () {
        // Keep hidden on fetch failure
      });
  }

  function initBlock(section, force) {
    if (!section) return;
    if (!force && section.dataset.rvInit === 'true') return;
    section.dataset.rvInit = 'true';

    var settings = getSettings(section);
    if (settings.currentProductId && window.DeskyRecentlyViewed) {
      window.DeskyRecentlyViewed.save(settings.currentProductId);
    }

    fetchProducts(section);
  }

  function initAll(root, force) {
    var scope = root || document;
    scope.querySelectorAll('[data-section-type="desky-recently-viewed"]').forEach(function (section) {
      initBlock(section, force);
    });
  }

  window.DeskyRecentlyViewed = window.DeskyRecentlyViewed || {
    save: function (id) {
      var items = this.getItems();
      var normalizedId = Number(id);

      items = items.filter(function (item) {
        return Number(item) !== normalizedId;
      });
      items.unshift(normalizedId);

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
      } catch (e) {
        // Safari private mode
      }
    },
    getItems: function () {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return [];
      }
    },
  };

  window.DeskyRecentlyViewed.initBlock = initBlock;
  window.DeskyRecentlyViewed.initAll = initAll;

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('desky:overview-hydrated', function (event) {
    if (event.detail && event.detail.target) {
      initAll(event.detail.target);
    }
  });

  // Theme editor: section HTML is replaced on every setting change
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    initAll(event.target, true);
  });
})();
